import MarketingPage from "../components/MarketingPage";
import { APP_STORE_URL, ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema } from "../lib/seo";

export default function SpottedALook() {
  return (
    <MarketingPage
      seo={{
        title: "Spotted a Look? Try It On With AI | C-STYL",
        description: "See an outfit on a celebrity, influencer or friend? Upload the photo and C-STYL identifies the pieces, turns them into clean product-style images, and lets you try them on.",
        path: "/spotted-a-look",
        testid: "spotted-a-look-page",
        jsonLd: [ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Spotted a Look", path: "/spotted-a-look" }])],
      }}
      crumb="Spotted a Look"
      eyebrow="See a look, try it on"
      h1="See a Look. Try It On."
      lead="See an outfit on a celebrity, influencer, friend, or anyone else? Upload the photo to C-STYL and make the look your own."
      sections={[
        { h2: "How Spotted a Look works", bullets: ["Spot a look and upload the photo", "C-STYL identifies the clothing pieces in it", "Each piece becomes a clean, product-style image", "Try the pieces individually or together", "Add the ones you love to your closet"] },
        { h2: "Try it on yourself", p: ["Spotted pieces work with AI virtual try-on, so you can see a single item or the full spotted look on your own body before deciding."] },
        { h2: "A note on identification", p: ["C-STYL identifies clothing pieces so you can recreate the style. It does not claim to match exact brands or specific products."] },
      ]}
      cta={{ label: "Download C-STYL", href: APP_STORE_URL, external: true }}
    />
  );
}
